import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMapper from "../helpers/JsonMapper";
import snackCase from "lodash-es/snakeCase";
var _attributes = /*#__PURE__*/new WeakMap();
export default class Option extends JsonMapper {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [Option.option_name_attribute_name]: null,
      [Option.discount_attribute_name]: null,
      [Option.quantity_attribute_name]: 1,
      [Option.sale_price_attribute_name]: 1,
      [Option.normal_price_attribute_name]: 1
    });
    data[Option.getNameAttributeName()] = snackCase(data[Option.getNameAttributeName()]);
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getNameAttributeName() {
    return Option.option_name_attribute_name;
  }
  static getDiscountAttributeName() {
    return Option.discount_attribute_name;
  }
  static getQuantityAttributeName() {
    return Option.quantity_attribute_name;
  }
  static getNormalPriceAttributeName() {
    return Option.normal_price_attribute_name;
  }
  static getSalePriceAttributeName() {
    return Option.sale_price_attribute_name;
  }
  static getOptionTypes() {
    return [Option.UPSELL, Option.CROSS_SELL];
  }
  getOptionName() {
    return this.getAttribute(Option.option_name_attribute_name);
  }
  getDiscount() {
    return this.getAttribute(Option.discount_attribute_name);
  }
  getQuantity() {
    return this.getAttribute(Option.quantity_attribute_name);
  }
  getSalePrice() {
    return this.getAttribute(Option.sale_price_attribute_name);
  }
  getNormalPrice() {
    return this.getAttribute(Option.normal_price_attribute_name);
  }
}
_defineProperty(Option, "UPSELL", 'upsell');
_defineProperty(Option, "CROSS_SELL", 'cross-sell');
_defineProperty(Option, "NORMAL_OFFER_TYPE", 'normal');
_defineProperty(Option, "WARNING_OFFER_TYPE", 'warranty');
_defineProperty(Option, "DISCOUNT_PATTERN", /({{dis}})?({{up}})?/g);
_defineProperty(Option, "option_name_attribute_name", 'option_name');
_defineProperty(Option, "discount_attribute_name", 'discount');
_defineProperty(Option, "quantity_attribute_name", 'quantity');
_defineProperty(Option, "sale_price_attribute_name", 'sale_price');
_defineProperty(Option, "normal_price_attribute_name", 'normal_price');